<!--
    描述：详细分析 --- vxe-table 版本
    时间：2021-10-22
    Created by 王帅
-->
<template>
    <div class="h100">
        <vxe-table :loading="loading" border highlight-hover-row highlight-current-row ref="xTable" auto-resize resizable align="center" height="auto" size="small" show-footer :footer-method="getSummaries" :sort-config="{ trigger: 'cell' }" :cell-class-name="cellClassName" :header-cell-class-name="headerCellClassName" @header-cell-click="onHeaderClick">
            <vxe-column type="seq" width="70" title="序号" sortable></vxe-column>
            <vxe-column field="sname" title="单位工程名称" sortable show-overflow min-width="160"></vxe-column>
            <vxe-column field="code" title="清单编码" sortable show-overflow width="130"></vxe-column>
            <!-- 对比列 1 -->
            <vxe-colgroup field="type1">
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="priceType1" size="small">
                        <el-option v-for="(item, index) in priceTypeList" :key="'价格类别1' + index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
                <!-- 合并列 -->
                <vxe-column v-for="(item, index) in listData.filterArr" :key="'筛选列' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column v-for="(item, index) in listData.normalArr" :key="'筛选列2' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                </vxe-column>
            </vxe-colgroup>
            <!-- 对比列 2 -->
            <vxe-colgroup field="type2">
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="priceType2" size="small">
                        <el-option v-for="(item, index) in priceTypeList" :key="'价格类别2' + index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
                <!-- 合并列 -->
                <vxe-column v-for="(item, index) in listData.filterArr2" :key="'筛选列' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column v-for="(item, index) in listData.normalArr2" :key="'筛选列2' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                </vxe-column>
            </vxe-colgroup>
            <!-- 异常原因 -->
            <vxe-column v-for="(item, index) in reasonCloumn" :key="'异常原因' + index" :title="item.label" :field="item.key" :visible="item.visible" min-width="250" :align="item.align" :header-align="item.headerAlign" :show-overflow="item.showOverFlow">
                <template #default="{ row }">
                    {{ row.reasons.replace(/[;；]/g,"$&\r\n") }}
                </template>
            </vxe-column>
            <!-- 备注 -->
            <vxe-column v-for="(item, index) in remarkCloumn" :key="'说明' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :align="item.align" :header-align="item.headerAlign">
                <template #default="{ row }">
                    <span v-if="row.hasRemark ===1" class="blue-text cursor-pointer" @click="editRemark(row)">编辑</span>
                    <span v-else class="gray-text cursor-pointer" @click="editRemark(row)">编辑</span>
                </template>
            </vxe-column>
            <!-- 增减量 -->
            <vxe-colgroup title="增减量" align="center" field="amount">
                <!-- 合并列 -->
                <vxe-column v-for="(item, index) in compareArr3" :key="'增减量' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    <!-- -->
                </vxe-column>
            </vxe-colgroup>
            <!-- 增减幅度 -->
            <vxe-colgroup title="增减幅度" align="center" field="amountRate">
                <!-- 合并列 -->
                <vxe-column v-for="(item, index) in compareArr4" :key="'增减幅度' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    <!-- -->
                </vxe-column>
            </vxe-colgroup>
        </vxe-table>
        <!-- 列过滤弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width" :close-on-click-modal="false" @closed="handleClose">
            <!-- 列过滤 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogObj.visible && dialogObj.type === 'filter'">
                <!-- 对比列筛选 -->
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">{{ getPhaseObj.name1 }}
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr1')" v-model="checkAll.compare1">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr1" :label="item.key" :key="'对比列1' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">{{ getPhaseObj.name2 }}
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr2')" v-model="checkAll.compare2">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr2" :label="item.key" :key="'对比列2' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">异常原因
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'reasonCloumn')" v-model="checkAll.reasons">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in reasonCloumn" :label="item.key" :key="'对比列3' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">说明
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'remarkCloumn')" v-model="checkAll.remark">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in remarkCloumn" :label="item.key" :key="'对比列3' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">增减量
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr3')" v-model="checkAll.compare3">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr3" :label="item.key" :key="'对比列4' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">增减幅度
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr4')" v-model="checkAll.compare4">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr4" :label="item.key" :key="'对比列5' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogObj.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="btnLoading" @click="doFilter">确 定
                    </el-button>
                </div>
            </div>

            <!-- 添加备注说明 -->
            <div class="h100 notice-container" v-if="dialogObj.visible && dialogObj.type === 'remark'">
                <div class="notice-header">
                    <span>单位工程名称： <i class="bold-text">{{ currentRow.sname }}</i></span>
                    <span class="ml10">清单编码： <i class="bold-text">{{ currentRow.code }}</i></span>
                </div>
                <template v-if="remarkList.length > 0">
                    <p class="sub-title">其它备注： </p>
                    <div class="content-wrap" >
                        <div class="notice-box" v-for="(item, index) in remarkList" :key="'remark' + index">
                            <p>
                                <i class="el-icon-user-solid"></i>
                                <span class="ml10">{{ item.userName }}</span>
                                <span class="ml10">{{ item.createDate }}</span>
                            </p>
                            <p>{{ item.remark }}</p>
                        </div>
                    </div>
                </template>

                <!-- 底部评论区域 -->
                <div slot="footer" class="notice-footer">
                    <el-input type="textarea" v-model="currentRow.newRemark" @input="$forceUpdate()" placeholder="请输入修正异常项原因..." :autosize="{minRows: 2}" maxlength="200" show-word-limit></el-input>
                    <div class="text-center mt20">
                        <el-button @click="dialogObj.visible = false" size="small">取 消
                        </el-button>
                        <el-button type="primary" size="small" :loading="btnLoading" @click="doPublish">发 布
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { selectConditionArray, getLaborData, getRemarks, saveRemarks } from "@/api/modules/analysisDetail";

export default {
    name: "",
    data() {
        return {
            loading: false,
            priceType1: "1007002", // 默认控制价
            priceType2: "1007003", // 默认中标价
            priceTypeList: [], // 价格类别下拉数组
            curColumn: '', // 当前点击的列 property
            allTableData: [], // 全部数据
            // 暂存的 当前参数
            queryParams: {},
            // 列过滤弹窗
            dialogObj: {
                title: "列过滤",
                visible: false,
                width: "1000px",
                type: "filter",
                exportExcel: false,
            },
            btnLoading: false,
            allColumns: [],
            // 全选
            checkAll: {
                compare1: false,
                compare2: false,
                reasons: true,
                remark: true,
                compare3: true,
                compare4: true,
            },
            filterObj: {
                codeArr: [], // 当前绑定的编码数组
                codeList: [], // 全部编码数组
                // 清单名称过滤数组
                nameList: [],
                // 计量单位数组
                unitList: [],
            },
            // 对比价格1 列
            compareArr1: [
                {
                    label: "清单名称",
                    key: "str1.projectName",
                    visible: true,
                    width: "200",
                    minWidth: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str1.projectName);
                    },
                },
                {
                    label: "清单特征",
                    key: "str1.projectFeatures",
                    visible: false,
                    minWidth: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "计量单位",
                    key: "str1.unit",
                    visible: true,
                    width: "110",
                    minWidth: "0",
                    align: "center",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str1.unit);
                    },
                },
                {
                    label: "工程量",
                    key: "str1.quantity",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str1.quantity, 3)
                    }
                },
                {
                    label: "单价",
                    key: "str1.rateCost",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str1.rateCost, 2)
                    }
                },
                {
                    label: "合价",
                    key: "str1.addup",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str1.addup, 2)
                    }
                },
            ],
            // 对比价格2 列
            compareArr2: [
                {
                    label: "清单名称",
                    key: "str2.projectName",
                    visible: true,
                    width: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str2.projectName);
                    },
                },
                {
                    label: "清单特征",
                    key: "str2.projectFeatures",
                    visible: false,
                    width: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "计量单位",
                    key: "str2.unit",
                    visible: true,
                    width: "110",
                    minWidth: "0",
                    align: "center",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str2.unit);
                    },
                },
                {
                    label: "工程量",
                    key: "str2.quantity",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.quantity, 3)
                    }
                },
                {
                    label: "单价",
                    key: "str2.rateCost",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.rateCost, 2)
                    }
                },
                {
                    label: "合价",
                    key: "str2.addup",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.addup, 2)
                    }
                },
            ],
            // 异常原因
            reasonCloumn: [
                {
                    label: "异常原因",
                    key: "reasons",
                    visible: true,
                    width: "200",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                }
            ],
            // 说明
            remarkCloumn: [
                {
                    label: "说明",
                    key: "remark",
                    visible: true,
                    width: "100",
                    align: "center",
                    headerAlign: "center",
                    sortable: true,
                }
            ],
            // 增减量 列
            compareArr3: [
                {
                    label: "工程量",
                    key: "decrement.decrementQuality",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
                {
                    label: "单价",
                    key: "decrement.decrementRateCost",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
                {
                    label: "合价",
                    key: "decrement.decrementAddup",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
            ],
            // 增减幅度 列
            compareArr4: [
                {
                    label: "工程量",
                    key: "range.rangeQuality",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
                {
                    label: "单价",
                    key: "range.rangePrice",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
                {
                    label: "合价",
                    key: "range.rangeSumPrice",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                },
            ],
            // 备注说明
            currentRow: {
                newRemark: ''
            }, // 当前行对象
            remarkList: []
        };
    },
    created() {
        // 获取期数含价格的类型数组
        this.getPriceList()
    },
    methods: {
        // 初始获取期数
        getPriceList() {
            this.priceTypeList = [];
            selectConditionArray({
                    id: this.curProjectId,
                })
                .then((res) => {
                    this.priceTypeList = res.data;
                })
                .catch((err) => {});
        },

        // 滚动加载
        loadData() {
            let $table = this.$refs.xTable;

            // 如果没选单位工程
            if (this.queryParams.treeIds.length === 0) {
                $table ? $table.loadData([]) : "";
                return;
            }

            this.getTableData().then((data) => {
                if ($table) {
                    $table.loadData(data);
                }
            });

            this.$emit('onSuccess');
        },

        // 初始获得数据
        getTableData() {
            this.loading = true;
            let query = this.$utils.clone(this.queryParams, true);

            return new Promise((resolve) => {
                getLaborData(query)
                    .then((res) => {
                        this.loading = false;
                        // 保存全部数据
                        this.allTableData = res.data.list;

                        resolve(res.data.list);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            });
        },

        // 获取表格数据
        getListData() {
            return this.$refs.xTable.getTableData().visibleData || []
        },

        // 切换 全部数据/异常数据
        changeData(showAll) {
            this.loading = true;
            let _errorData =
                this.allTableData.filter((x) => x.reasons !== "") || [];

            if (showAll) {
                this.$refs.xTable.loadData(this.allTableData);
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            } else {
                this.$refs.xTable.loadData(_errorData);
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }
        },

        // 打开列过滤弹窗
        openFilter() {
            this.dialogObj.title = "列过滤";
            this.dialogObj.type = "filter";
            this.dialogObj.visible = true;
        },

        // 确认过滤
        doFilter() {
            this.$refs.xTable.refreshColumn();

            this.handleClose()
        },

        // 列过滤全选事件
        handleAllChange(status, type) {
            this[type].map(x => {
                x.visible = status
            })
        },

        // 列过滤弹窗关闭
        handleClose() {
            this.dialogObj.visible = false;
            this.btnLoading = false;
        },

        // 列样式
        cellClassName({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {

            // 类型1 的
            let arr1 = [
                'str1.projectName',
                'str1.projectFeatures',
                'str1.unit',
                'str1.quantity',
                'str1.rateCost',
                'str1.addup',
            ]
            if (this.curColumn === "type1" && arr1.includes(column.property)) {
                return "active-cell";
            }

            // 类型2 的
            let arr2 = [
                'str2.projectName',
                'str2.projectFeatures',
                'str2.unit',
                'str2.quantity',
                'str2.rateCost',
                'str2.addup',
            ]
            if (arr2.includes(column.property) && row.reasons !== '') {
                return 'error-cell'
            }
            if (this.curColumn === "type2" && arr2.includes(column.property)) {
                return "active-cell";
            }

            // 增减量的
            let arr3 = [
                'decrement.decrementQuality',
                'decrement.decrementRateCost',
                'decrement.decrementAddup'
            ]
            if (this.curColumn === "amount" && arr3.includes(column.property)) {
                return "active-cell";
            }

            // 增减幅度的
            let arr4 = [
                'range.rangeQuality',
                'range.rangePrice',
                'range.rangeSumPrice'
            ]
            if (this.curColumn === "amountRate" && arr4.includes(column.property)) {
                return "active-cell";
            }

            // 剩下单独的
            if (this.curColumn === column.property) {
                return "active-cell";
            }

            return ''
        },

        // 表头列样式
        headerCellClassName({ $rowIndex, column, columnIndex, $columnIndex }) {
            // 类型2 的
            let arr2 = [
                'str2.projectName',
                'str2.projectFeatures',
                'str2.unit',
                'str2.quantity',
                'str2.rateCost',
                'str2.addup',
            ]
            if (column.property === "type2") {
                return 'compare-header';
            }
            if (column.level === 2 && arr2.includes(column.property)) {
                return 'compare-header';
            }
        },

        // 列文字颜色
        setColor(row, key) {
            let _property = key.slice(5)
            let _con1 = row.analysisFields && row.analysisFields.includes('plusItem')
            let _con2 = row.analysisFields && row.analysisFields.includes(_property)
            return {
                color: _con1 || _con2 ? '#f00' : ''
            }
        },

        // 表头点击事件
        onHeaderClick({ $rowIndex, column, columnIndex, $columnIndex, triggerResizable, triggerSort, triggerFilter, $event }) {
            this.curColumn = column.property;
        },

        // toFixed
        NumberToFixed(prop, digit) {
            let num = digit === 2 ? '0.00' : '0.000'
            return prop ? prop.toFixed(digit) : num
        },

        // 表尾合计行
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            let sum2 = 0,
                sum1 = 0;

            columns.forEach((column, index) => {
                sums[index] = null;

                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }

                // 第一个 合价
                if (column.property === "str1.addup") {
                    let values = data.map((x) => parseFloat(x.str1.addup));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sum1 = sums[index];
                        sums[index] = sums[index].toFixed(2) + " 元";
                    }
                }

                // 第二个合价
                if (column.property === "str2.addup") {
                    let values = data.map((x) => parseFloat(x.str2.addup));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sum2 = sums[index];
                        sums[index] = sums[index].toFixed(2) + " 元";
                    }
                }

                // 增减量 合价
                if (column.property === "decrement.decrementAddup") {
                    sums[index] = sum2.sub(sum1).toFixed(2) + " 元";
                }

                // 增减幅度 合价
                if (column.property === "range.rangeSumPrice") {
                    sums[index] =
                        sum1 !== 0 ? (sum2 / sum1 - 1).mul(100).toFixed(2) + " %" : null;
                }
            });
            return [sums];
        },

        // 点击编辑备注说明
        editRemark(row) {
            this.currentRow = this.$utils.clone(row, true);
            this.currentRow.newRemark = '';

            this.dialogObj.title = "备注说明";
            this.dialogObj.type = "remark";
            this.dialogObj.visible = true;
            this.getRemarkList()
        },

        // 获取备注列表
        getRemarkList() {
            let params = {
                projectId: this.curProjectId,
                treeId: this.currentRow.treeId,
                billId1: this.currentRow.str1.id,
                billId2: this.currentRow.str2.id,
                type: '0',
                code: this.currentRow.code
            }
            getRemarks(params)
                .then(res => {
                    this.remarkList = res.data
                })
                .catch(err => {})
        },

        // 确认发布 备注
        doPublish() {
            let params = {
                projectId: this.curProjectId,
                treeId: this.currentRow.treeId,
                billId1: this.currentRow.str1.id,
                billId2: this.currentRow.str2.id,
                type: '0',
                code: this.currentRow.code,
                remark: this.currentRow.newRemark
            }
            saveRemarks(params)
                .then(res => {
                    this.handleClose()
                    this.loadData();
                })
                .catch(err => {})
        },

        // 清除全部条件
        clearAll() {
            this.$refs.xTable.clearAll();
        },
    },
    computed: {
        // 项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },

        // 获取选中的 phase的Type
        getPhaseObj() {
            let _item1 = this.priceTypeList.find((x) => x.value === this.priceType1)
            let _item2 = this.priceTypeList.find((x) => x.value === this.priceType2)

            let _name1 = _item1 ? _item1.name : ''
            let _name2 = _item2 ? _item2.name : ''

            return {
                type1: _item1 ? _item1.type : '',
                type2: _item2 ? _item2.type : '',
                name1: _name1,
                name2: _name2,
                nameStr: _name1 + ',' + _name2
            }
        },

        // 当前选择的单位
        curTendererName() {
            return 'xxx'
            let _item = this.tendererList.find((x) => x.id === this.priceType2);
            return _item ? _item.sname : "投标单位";
        },

        // 需要过滤的数据(材料名称， 单位)
        listData() {
            let _filter = this.compareArr1.filter((x) => x.needFilter);
            let _noFilter = this.compareArr1.filter((x) => !x.needFilter);
            let _filter2 = this.compareArr2.filter((x) => x.needFilter);
            let _noFilter2 = this.compareArr2.filter((x) => !x.needFilter);
            return {
                filterArr: _filter,
                normalArr: _noFilter,
                filterArr2: _filter2,
                normalArr2: _noFilter2,
                'str1.projectName': this.filterObj.nameList,
                'str1.unit': this.filterObj.unitList,
                'str2.projectName': this.filterObj.nameList,
                'str2.unit': this.filterObj.unitList,
            };
        },
    },
    watch: {
        // 监听复选框变化
        compareArr1: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare1 = !_false
            },
            deep: true
        },
        // 监听复选框变化
        compareArr2: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare2 = !_false
            },
            deep: true
        },

        // 异常原因
        reasonCloumn: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.reasons = !_false
            },
            deep: true
        },

        // 备注
        remarkCloumn: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.remark = !_false
            },
            deep: true
        },

        // 增减量
        compareArr3: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare3 = !_false
            },
            deep: true
        },

        // 增减幅度
        compareArr4: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare4 = !_false
            },
            deep: true
        },

        // 监听两个下拉选的变化
        priceType1(val) {
            this.queryParams.phases = val + "," + this.priceType2;
            this.queryParams.phase1 = this.priceType1
            this.queryParams.phase2 = this.priceType2
            this.queryParams.type1 = this.getPhaseObj.type1
            this.queryParams.type2 = this.getPhaseObj.type2
            this.loadData();
        },
        priceType2(val) {
            this.queryParams.phases = this.priceType1 + "," + val;
            this.queryParams.phase1 = this.priceType1
            this.queryParams.phase2 = this.priceType2
            this.queryParams.type1 = this.getPhaseObj.type1
            this.queryParams.type2 = this.getPhaseObj.type2
            this.loadData();
        },
    }
};
</script>
<style scoped lang="less">
.check-row {
    margin-bottom: 7px;
    background-color: #a3e3ff;
    height: 35px;
    line-height: 35px;
    font-weight: 700;
    color: #333;

    .check-name {
        border-right: 1px solid #1d7f8a;
        text-align: right;
        padding-right: 15px;
    }

    .check-content {
        text-align: left;
        padding-left: 15px;
    }
}

.check-row:nth-of-type(2) {
    background-color: #f5f5ad;
}

.check-row:nth-of-type(3) {
    background-color: #ffe4c4;
}

.check-row:nth-of-type(4) {
    background-color: #7fffd4;
}

.blue-text {
    color: #2671cc;
}

.gray-text {
    color: rgba(71, 68, 72, 0.4);
}
</style>